
//Provides context to MaterialInputDialog; 
//properties and validation differ based on where 
//the component is used

export enum MaterialContext {
    MaterialTable,
    MaterialRow,
    MaterialRowApproved,
    StoredAssembly,
    Inventory
}
